import { NetworkConfigs } from "./type";

export const networkConfig: NetworkConfigs = {
  mainnet: {
    network: "mainnet",
    jsonRpcUrl: "https://mainnet.hashio.io/api",
    mirrorNodeUrl: "https://mainnet.mirrornode.hedera.com",
    chainId: "0x127",
  }
};
